import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["button", "modal", "iosInstructions", "firefoxInstructions", "browserInstructions", "nativeHint"]

  connect() {
    this.deferredPrompt = null
    this.beforeInstallPrompt = this.beforeInstallPrompt.bind(this)
    this.appInstalled = this.appInstalled.bind(this)

    window.addEventListener("beforeinstallprompt", this.beforeInstallPrompt)
    window.addEventListener("appinstalled", this.appInstalled)

    if (this.installed || !this.mobile) {
      this.hideButton()
    } else {
      this.showButton()
    }
  }

  disconnect() {
    window.removeEventListener("beforeinstallprompt", this.beforeInstallPrompt)
    window.removeEventListener("appinstalled", this.appInstalled)
    this.modal?.dispose()
  }

  beforeInstallPrompt(event) {
    if (!this.mobile) return

    event.preventDefault()
    this.deferredPrompt = event
    this.showNativeHint()
    this.showButton()
  }

  async install() {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt()
      const choice = await this.deferredPrompt.userChoice
      this.deferredPrompt = null

      if (choice.outcome === "accepted") this.hideButton()
      return
    }

    this.showInstructions()
  }

  appInstalled() {
    this.deferredPrompt = null
    this.hideButton()
  }

  showInstructions() {
    this.iosInstructionsTarget.hidden = !this.ios
    this.firefoxInstructionsTarget.hidden = !this.firefoxAndroid
    this.browserInstructionsTarget.hidden = this.ios || this.firefoxAndroid
    this.instance.show()
  }

  showNativeHint() {
    if (this.hasNativeHintTarget) this.nativeHintTarget.hidden = false
  }

  showButton() {
    if (this.mobile && !this.installed) this.buttonTarget.classList.remove("d-none")
  }

  hideButton() {
    this.buttonTarget.classList.add("d-none")
  }

  get instance() {
    this.modal ||= Modal.getOrCreateInstance(this.modalTarget)
    return this.modal
  }

  get installed() {
    return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true
  }

  get ios() {
    return /iphone|ipad|ipod/i.test(window.navigator.userAgent) ||
      (window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1)
  }

  get firefoxAndroid() {
    return /android/i.test(window.navigator.userAgent) && /firefox/i.test(window.navigator.userAgent)
  }

  get mobile() {
    if (window.navigator.userAgentData?.mobile === true) return true

    return /android|iphone|ipad|ipod|mobile/i.test(window.navigator.userAgent) || this.ios
  }
}
